export const en = {
    adjust: 'Refine',
    cancel: 'Cancel',
    'phrase-with-minus-words': 'Keyword with negative keywords',
    set: 'OK'
};
